var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 384,
    viewBox: "0 0 384 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.861 77.565C175.755 50.6966 203.603 32 236 32C280.856 32 316.8 67.7482 316.8 111.333C316.8 114.546 316.606 117.706 316.232 120.805C315.318 128.355 319.846 135.506 327.062 137.907C341.714 142.784 352 156.333 352 172C352 191.653 335.755 208 315.2 208H280C271.163 208 264 215.163 264 224C264 232.837 271.163 240 280 240H315.2C352.966 240 384 209.784 384 172C384 146.39 369.715 124.245 348.792 112.65C348.797 112.211 348.8 111.773 348.8 111.333C348.8 49.6162 298.067 0 236 0C195.602 0 160.086 20.9803 140.157 52.6018C136.957 52.2043 133.699 52 130.4 52C96.0096 52 66.6469 74.1566 56.5438 105.078C24.5461 110.779 0 138.397 0 172C0 209.784 31.0339 240 68.8 240H104C112.837 240 120 232.837 120 224C120 215.163 112.837 208 104 208H68.8C48.2448 208 32 191.653 32 172C32 152.347 48.2448 136 68.8 136H69.4238C77.372 136 84.1154 130.165 85.2578 122.299C88.3754 100.834 107.245 84 130.4 84C135.098 84 139.6 84.6909 143.822 85.9622C151.371 88.235 159.45 84.6715 162.861 77.565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 246.627L228.686 267.314C234.934 273.562 245.065 273.562 251.313 267.314C257.561 261.066 257.561 250.934 251.313 244.686L203.313 196.686C197.065 190.438 186.934 190.438 180.686 196.686L132.686 244.686C126.438 250.934 126.438 261.066 132.686 267.314C138.934 273.562 149.065 273.562 155.313 267.314L176 246.627V368C176 376.837 183.163 384 192 384C200.836 384 208 376.837 208 368V246.627Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 384,
    height: 384,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.c5468fcad9f5075150c276c03ff23cd9.svg";
export { ForwardRef as ReactComponent };